import { PermitStatus } from '@core/entities/permit/PermitBase'
import React from 'react'
import Countdown from '@core/Countdown'
import { SxProps, Theme, Tooltip } from '@mui/material'
import { Chip } from '@common/material'
import { Permit } from '@core/entities/permit/Permit'

export const usePermitChips = () => {
  const primaryChip = (
    permit: { status: PermitStatus; endsOn: string },
    chipProps?: {
      sx?: SxProps<Theme>
      dataTest?: string
      size?: 'small' | 'medium'
    },
  ) => {
    // We want to consider the EXTENSION_REQUESTED status as open for the purpose of the primary chip
    const permitStatus =
      permit?.status === 'EXTENSION_REQUESTED' ? 'OPEN' : permit?.status
    const primaryChipLabel = () => {
      return (
        <>
          <span>{Permit.getStatusString(permitStatus)}</span>
          {permitStatus === 'OPEN' && (
            <span>
              <> – </>
              <span>
                <Countdown pollFrequency={400} value={permit?.endsOn} />
              </span>
            </span>
          )}
        </>
      )
    }
    return (
      <Tooltip title={primaryChipLabel()}>
        <Chip
          data-test={chipProps?.dataTest}
          color={Permit.getStatusChipColor(permitStatus)}
          label={primaryChipLabel()}
          sx={chipProps?.sx}
          size={chipProps?.size}
        />
      </Tooltip>
    )
  }

  return {
    primaryChip,
  }
}
